const GetAllTerms_query = `
query($clientId: Int!) {
  allTerms(clientId: $clientId) {
    termId
    name
    termUuid
    formId {
      formId
      formUuid
      clientId {
        name
      }
      name
      approved
    }
    termPeriods{
      periodId
      termId{
        termId
      }
      name
      desc
      noOfWeeks
      inSprint
      sequence
      startDate
      endDate
      dateRange
    }
    startDate
    endDate
    urlActivated
    noOfSeats     
    noOfWeeks
    noOfApplicants
    noOfTeams
    current
    termTemplateId
    termTemplate{
      termTemplateId
      name
    }
  }
}
`;
const CreateTerm_mutate = `
    mutation createTerm(
      $name: String!
      $formId: Int!
      $startDate: String!
      $endDate: String!
      $urlActivated: Boolean
      $noOfSeats: Int!
      ) {
      createTerm(
        name: $name,
        formId: $formId,
        startDate: $startDate,
        endDate: $endDate,
        urlActivated: $urlActivated,
        noOfSeats: $noOfSeats ) {
        term
        {
          termId
          formId
          {
            formId
            clientId
            {
              name
            }
            name
            approved
          }
          name
          startDate
          endDate
          urlActivated
          noOfSeats
          current
        }
      }
    }
`;

const CreateFirstTerm_mutate = `
    mutation createFirstTerm(
      $name: String!
      $formId: Int!
      $startDate: String!
      $noOfSeats: Int!
      $template: String!
      ) {
      createFirstTerm(
        name: $name,
        formId: $formId,
        startDate: $startDate,
        noOfSeats: $noOfSeats,
        template: $template) {
        term
        {
          termId
          formId
          {
            formId
            clientId
            {
              name
            }
            name
            approved
          }
          name
          startDate
          noOfSeats
          termUuid
          current          
        }
      }
    }
`;

const NoOfApplicants_query = `
query($termId: Int!) {
  noOfTermApplicants(termId: $termId)
}
`;

const GetFormInfoByTermUuid_query = `
  query( $termUuid: String!)
  {
    getFormInfoByTermUuid(termUuid: $termUuid)
    {
      termId
      formId{
        formId 
        formUuid
        name
        createDate
        approved
        termList
        clientId {
          clientId
          name
          tenantId {
            tenantId
            name
            contactEmail
            statesList{
              id 
              name 
              code
            }
            countriesList{
              id 
              name 
              code
            }
          }
        }
      }
      name
      startDate
      endDate
      urlActivated
      noOfSeats
      current
    }
  }    
`;

const EditTerm_mutate = `
    mutation editTerm(
      $termUuid: String!
      $name: String!
      $formId: Int!
      $startDate: String!
      $endDate: String!
      $urlActivated: Boolean
      $noOfSeats: Int!
      ) {
      editTerm(
        termUuid: $termUuid,
        name: $name,
        formId: $formId,
        startDate: $startDate,
        endDate: $endDate,
        urlActivated: $urlActivated,
        noOfSeats: $noOfSeats ) {
        term
        {
          termId
          termUuid
          formId
          {
            formId
            clientId
            {
              name
            }
            name
            approved
          }
          name
          startDate
          endDate
          urlActivated
          noOfSeats
          current          
        }
      }
    }
`;

const EditTermName_mutate = `
    mutation editTermName(
      $termUuid: String!
      $name: String!
      
      ) {
      editTermName(
        termUuid: $termUuid,
        name: $name ) {
        term
        {
          termId
          termUuid
          formId
          {
            formId
            clientId
            {
              name
            }
            name
            approved
          }
          name
          startDate
          endDate
          urlActivated
          noOfSeats
          current
        }
      }
    }
`;

const GetTermDataByTermUuid_query = `
  query( $termUuid: String!)
  {
    getTermDataByTermUuid(termUuid: $termUuid)
    {
        termId
        name 
        notifyAll       
        formId
        {
          formId
          formUuid
          clientId
          {
            name
            clientId
            tenantId {
              tenantId
              name
              contactEmail
            }
          }
          name
        }
        termUuid
        startDate
        endDate
        urlActivated
        noOfSeats
        noOfWeeks
        editable
        termTemplateId
        current
    }
  }    
`;

const ChangeActivateStatus_mutate = `
    mutation changeActivateStatus(
      $termId: Int!,
      $urlActivated: Boolean!) {
      changeActivateStatus(
        termId: $termId,
        urlActivated: $urlActivated) {
        term
        {
          termId
          termUuid
          name
          urlActivated          
        }
      }
    }
`;

const UpdateNoOfSeats_mutate = `
    mutation updateNoOfSeats(
      $termId: Int!,
      $noOfSeats: Int!) {
      updateNoOfSeats(
        termId: $termId,
        noOfSeats: $noOfSeats) {
        term
        {
          termId
          termUuid
          name
          noOfSeats          
        }
      }
    }
`;

const DeleteTerm_mutate = `
    mutation delete_term($termId: Int!) {
      deleteTerm(termId: $termId) {
        response
      }
    }
`;

const SetCurrentTeam_mutate = `
    mutation set_current_term($termId: Int!) {
      setCurrentTerm(termId: $termId) {
        response
      }
    }
`;

const GetCurrentTerm_query = `
  query( $clientId: Int!)
  {
    getCurrentTerm(clientId: $clientId)
    {
      termId
      termUuid
      name        
      formId
      {
        formId
        formUuid
        clientId
        {
          name
          clientId
          tenantId {
            tenantId
            name
            contactEmail
          }
        }
        name
      }
      termUuid
      startDate
      endDate
      urlActivated
      noOfSeats
      noOfWeeks
      editable
      termTemplateId
      current
    }
  }
`;

const DownloadApplicants_mutate = `
  mutation download_applicants( $termIds: [Int]!, $dataType: String! ) {
    downloadApplicants(termIds: $termIds, dataType: $dataType) {
      url
    }
  }
`;


module.exports = {
  GET_ALL_TERMS_QUERY: GetAllTerms_query,
  CREATE_TERM_MUTATION: CreateTerm_mutate,
  CREATE_FIRST_TERM_MUTATION: CreateFirstTerm_mutate,
  NO_OF_APPLICANTS_QUERY: NoOfApplicants_query,
  GET_FORM_INFO_BY_TERM_UUID: GetFormInfoByTermUuid_query,
  EDIT_TERM_MUTATION: EditTerm_mutate,
  EDIT_TERM_NAME_MUTATION: EditTermName_mutate,
  GET_TERM_DATA_BY_TERM_UUID: GetTermDataByTermUuid_query,
  CHANGE_ACTIVATE_STATUS_MUTATION: ChangeActivateStatus_mutate,
  DELETE_TERM_MUTATION: DeleteTerm_mutate,
  UPDATE_NO_OF_SEATS_MUTATION: UpdateNoOfSeats_mutate,
  SET_CURRENT_TERM_MUTATION: SetCurrentTeam_mutate,
  GET_CURRENT_TERM_QUERY: GetCurrentTerm_query,
  DOWNLOAD_APPLICANTS_MUTATION: DownloadApplicants_mutate
};
